import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import type { PropsWithChildren, ReactNode } from 'react'
import { Heading2 } from '../Typography/Heading2.js'

const box = cva('relative p-3 sm:p-6 md:p-12 border border-gray-300 rounded-2xl bg-white shadow-lg h-full flex flex-col', {
  variants: {
    width: {
      fit: 'max-w-fit',
      full: 'w-full'
    }
  },
  defaultVariants: { width: 'fit' }
})

interface IProps extends VariantProps<typeof box>, PropsWithChildren {
  title?: string
  action?: ReactNode
}

export const Box = ({ children, title, action, width }: IProps) => {
  return (
    <div className={box({ width })}>
      {title && (
        <>
          <Heading2>{title}</Heading2>
          <hr />
        </>
      )}
      <div className="grow">{children}</div>
      <div className={'flex flex-row-reverse justify-between content-end'}>{action}</div>
    </div>
  )
}
